/// <reference path="./Box.ts" />
namespace HA.Core.HTML {
    //noinspection TsLint

    export class Pane extends Box {
        protected createByType(data: Map<any, any>, main: Tag) {
            const t = data.get("t");
            // const tag: List|any = null;
            switch (t) {
                case "pn" :
                    main.appendChild(new Pane(data));
                    break;
                case "mp" :
                    main.appendChild(new HA.Core.HTML.Panel.MediaPane(data));
                    break;
                default:
                    super.createByType(data, main);
                    return;
            }
            /*if (tag) {
                main.appendChild(tag);
            }*/
        }

        protected createSelf() {
            super.createSelf();
            this.addClass("pane");
        }
    }
}
